var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view moment",attrs:{"data-name":"moment"}},[_c('RailsContent',{attrs:{"data":_vm.medium,"is-medium":true}}),_c('PageHero',{attrs:{"title":'Moment.'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }